import { isCustomValue as e } from "./atoms-v2883.js";
import { isMotionValue as r } from "./atoms-v2884.js";
function u(o) {
  const t = r(o) ? o.get() : o;
  return e(t) ? t.toValue() : t;
}
export {
  u as resolveMotionValue
};
